import { GENTLING_CATEGORIES, THEME_COLORS } from '../../../constants/horseConstants';

/**
 * Gentling Checklist Component
 * Displays and manages gentling/training progress for a horse
 * @param {object} gentling - The gentling data object
 * @param {function} onChange - Callback when a checkbox changes
 * @param {boolean} readonly - Whether the checklist is read-only
 * @param {array} categories - Custom training categories (optional, falls back to GENTLING_CATEGORIES)
 */
const GentlingChecklist = ({ gentling = {}, onChange, readonly = false, categories }) => {
  // Use custom categories if provided, otherwise fall back to constants
  const trainingCategories = categories && Array.isArray(categories) && categories.length > 0 
    ? categories 
    : GENTLING_CATEGORIES;
  
  // Safety check - ensure gentling is an object
  const safeGentling = gentling && typeof gentling === 'object' ? gentling : {};
  
  const handleCheckboxChange = (category, itemKey, checked) => {
    if (readonly || !onChange) return;
    
    const updatedGentling = {
      ...safeGentling,
      [category]: {
        ...(safeGentling[category] || {}),
        [itemKey]: checked
      }
    };
    onChange(updatedGentling);
  };

  // Safety check for trainingCategories
  if (!trainingCategories || !Array.isArray(trainingCategories) || trainingCategories.length === 0) {
    return (
      <div className="text-sm text-gray-500 p-3 bg-gray-50 rounded-lg">
        No training categories available
      </div>
    );
  }

  return (
    <div className="space-y-2 bg-gray-50 p-3 rounded-lg max-h-96 overflow-y-auto">
      {trainingCategories.map((category) => {
        // Safety check for each category
        if (!category || !category.key || !category.items || !Array.isArray(category.items)) {
          return null;
        }
        
        return (
          <div key={category.key} className="space-y-1">
            <div className="font-medium text-sm" style={{ color: THEME_COLORS.primary }}>
              {category.label || category.key}
            </div>
            <div className="ml-4 space-y-1">
              {category.items.map((item) => {
                if (!item || !item.key) return null;
                
                return (
                  <label 
                    key={item.key} 
                    className={`flex items-center gap-2 p-1.5 rounded ${readonly ? '' : 'cursor-pointer hover:bg-gray-100'}`}
                  >
                    <input
                      type="checkbox"
                      checked={safeGentling[category.key]?.[item.key] || false}
                      onChange={(e) => handleCheckboxChange(category.key, item.key, e.target.checked)}
                      disabled={readonly}
                      className="w-4 h-4 rounded border-gray-300"
                      style={{ accentColor: THEME_COLORS.secondary }}
                    />
                    <span className="text-sm">{item.label || item.key}</span>
                  </label>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GentlingChecklist;
